import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { lastValueFrom } from 'rxjs';
import { AuthUser } from './auth.model';

export const setPasswordGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  // const profile = await lastValueFrom(authService.profile());
  const profile = authService.getUser();

  if (!profile) {
    void router.navigate(['/auth/login']);
    return false
  }

  if (!profile.is_set_password) {
    void router.navigate(['/set-password']);
    return false;
  }

  return true;
};
